import { MENU_JIAMENG_MARKETING } from '@constant'

export default {
  key: MENU_JIAMENG_MARKETING,
  id: '',
  title: '营销',
  icon: 'icon-yingxiao1',
  link: '/localMerchant/marketingCenter'
}
